var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "b-col",
        { attrs: { sm: "12", md: "6" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "3",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "pt-0" }, [
                _vm._v("Käyttöpaikan osoite")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.addressString))
              ]),
              _vm._v(" "),
              _c("font-awesome-icon", {
                style: _vm.tooltipStyle,
                attrs: {
                  icon: "exclamation-circle",
                  id: "tooltip-mp-street-d",
                  size: "lg"
                }
              }),
              _vm._v(" "),
              _vm.additionalAddressToMeteringPointAddress
                ? _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target: "tooltip-mp-street-d",
                        variant: "primary",
                        placement: "right",
                        triggers: "hover"
                      }
                    },
                    [
                      _vm._v(
                        "\n                Vaihdettu automaattisesti lisäosoitteen tilalle käyttöpaikan osoite.\n            "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "3",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Toivottu alkupäivä")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm._f("date")(_vm.contract.StartDate)))
              ])
            ]
          ),
          _vm._v(" "),
          _vm.contract.IsCustomerAddressInUse
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-lg": "3",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("label", { staticClass: "pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Asiakkaan osoite")))
                  ]),
                  _vm._v(" "),
                  _vm.contract.Customer.Address.COName
                    ? _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.contract.Customer.Address.COName)),
                        _c("br")
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.homeAddressString))
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isInvoicingMethodsInUse && _vm.contract.IsInvoicingAddressInUse
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-lg": "3",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("label", { staticClass: "pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Laskutusosoite")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.invoicingAddressString))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.memberShipName != null
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-lg": "3",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("label", { staticClass: "pt-0" }, [_vm._v("Jäsenyys")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(" " + _vm._s(_vm.memberShipName))
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { sm: "12", md: "6" } },
        [
          _vm.meteringPoint.GsrnCode
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "8",
                    "label-cols-lg": "2",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("label", { staticClass: "font-weight-bold pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Käyttöpaikkatunnus")))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.meteringPoint.GsrnCode))])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isInvoicingMethodsInUse && _vm.contract.IsInvoicingAddressInUse
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "8",
                    "label-cols-lg": "3",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("label", { staticClass: "pt-0" }, [
                    _vm._v(_vm._s(_vm.$t("Laskutustapa")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.invoicingMethodString))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.InvoicingMethod == _vm.InvoicingMethodEnum.Email
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "6",
                    "label-cols-lg": "3",
                    label: "",
                    "label-class": "pt-0",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.contract.DeliveryEmail))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.contract.InvoicingMethod ==
          _vm.InvoicingMethodEnum.CompanyEInvoice
            ? _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "6",
                    "label-cols-lg": "3",
                    label: "",
                    "label-class": "pt-0",
                    "label-align-md": "right"
                  }
                },
                [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.invoicingECompanyAddressString))
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }